module.exports = __webpack_public_path__ + "static/media/inf_74og75.009a7b1f.mp3";